import {ActivatedRouteSnapshot, CanActivateFn, GuardResult, MaybeAsync, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {GlobalsService} from '../../../src/app/services/globals.service';

/**
 * Auth guard, redirect user to login page if not logged-in
 * @param route Current route
 * @param state Current router state
 * @returns GuardResult
 */
export const authGuard: CanActivateFn = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot
): MaybeAsync<GuardResult> => {
    const globalsService: GlobalsService = inject(GlobalsService);
    return globalsService.sessionService.getIsReadyPromise().then(() => {
        return globalsService.sessionService.getUser() != null;
    });
};
